
/**
 * Module dependencies.
 */

import { UserType } from 'src/types/user';
import {
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * Endpoint.
 */

const endpoint = getApiEndpoint('createUser');

/**
 * Export `FormData` type.
 */

export type FormData = {
  company?: string | null,
  country_alpha2: string,
  district_id?: string | null,
  job_title?: string | null,
  location?: string | null,
  name: string,
  phone_number?: string | null,
  professional_type?: string | null,
  type: UserType
};

/**
 * `Query` type.
 */

type Query = {
  formData: FormData,
  token: string
};

/**
 * Export `createUser`.
 */

export async function createUser({ formData, token }: Query) {
  try {
    return await request.post(endpoint, formData, {
      headers: authorizationHeader(token)
    });
  } catch (error) {
    throw handleRequestError(error);
  }
}
